<div class="wo-confirmation-overlay">
  <iss-icon name="success-checkmark" class="wo-confirmation-overlay-icon" />
  <div class="wo-confirmation-overlay-title">{{ title }}</div>
  <ng-content/>
</div>
